import { render, staticRenderFns } from "./ApplicationsDetail.vue?vue&type=template&id=dee95032&scoped=true"
import script from "./ApplicationsDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetail.vue?vue&type=style&index=0&id=dee95032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee95032",
  null
  
)

export default component.exports